import { LenderStatus, LENDER_DETAILS_TYPE, EmiPlans } from '@/api/types';
import { LENDER_STATUS_MAPPING } from '@/constants';

export const isLenderStepPending = (status: LenderStatus): boolean => {
  return status === LENDER_STATUS_MAPPING.PENDING;
};

export const isLenderStepCompleted = (status: LenderStatus): boolean => {
  return status === LENDER_STATUS_MAPPING.COMPLETE;
};

export const getPlanStatus = (
  lenderDetails: LENDER_DETAILS_TYPE[],
  plan: EmiPlans,
): LENDER_DETAILS_TYPE | undefined => {
  const lenderDetailsForPlan = lenderDetails.find((l) => l.provider === plan.provider);
  return lenderDetailsForPlan;
};
